// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2aBP4","col":"styles_col__3Xhkb"};